import { Flex } from 'foundations-components/components/Flex';
import TableUIModeSelect from 'framework-listing-lib/internal/Table/components/TableUIModeSelect';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ListingLibTableHeaderRightSlot({
  children
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    paddingInlineEnd: "100",
    alignItems: "center",
    gap: "300",
    children: [/*#__PURE__*/_jsx(TableUIModeSelect, {}), children]
  });
}